import hash from "object-hash";
import "./FileCard.scss";

import { Placeholder } from "../Typography";
import formatBytes from "../../utils/formatBytes";
import { Button } from "../Button";

const CHAR_LIMIT = 18;

const FileCard = ({ name, size, url, onClickDelete }: any) => {
  const fileParts = name.split('.')
  const fileName = fileParts[0]
  const fileExtension = fileParts[1]

  return (
    <div className="file-card" key={hash(name)}>
      <Placeholder center onClick={() => window.open(url, "_blank")}>
        {name.length > CHAR_LIMIT
          ? `${fileName.substring(0, CHAR_LIMIT)}...${fileExtension}`
          : name}
      </Placeholder>
      <Placeholder>{formatBytes(size)}</Placeholder>
      {onClickDelete ? (
        <Button red small onClick={onClickDelete}>
          Eliminar
        </Button>
      ) : (
        <Button small onClick={() => window.open(url, "_blank")}>
          Abrir
        </Button>
      )}
    </div>
  );
};

export default FileCard;
